// NGRX
import {Action, createAction, props} from '@ngrx/store';
// Models
import { Permission } from '../_models/permission.model';


export const AllPermissionsRequested = createAction('[App Component] All Permissions Requested');
export const AllPermissionsLoaded = createAction('[Permissions Reducer] All Permissions Loaded',props<{permissions: Permission[]}>());
